import { render } from "./BlockCompany.vue?vue&type=template&id=06050a8a&scoped=true"
import script from "./BlockCompany.vue?vue&type=script&lang=js"
export * from "./BlockCompany.vue?vue&type=script&lang=js"

import "./BlockCompany.vue?vue&type=style&index=0&id=06050a8a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06050a8a"]])

export default __exports__